import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Footer from "../../Footer";
import getSymbolFromCurrency from "currency-symbol-map";

function AllShippings(props) {
  const { token } = isAutheticated();
  const [data, setdata] = useState([]);
  const [currency, setCurrency] = useState("");
  const [loading, setLoading] = useState(true);
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [showData, setShowData] = useState(data);


  useEffect(() => {
    async function fetchData() {
      await axios
        .get(`${API}/api/user`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setCurrency(res.data.data.settings.currency);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    fetchData();
  }, [token]);

  useEffect(() => {
    async function fetchData() {
      await axios
        .get(`${API}/api/shipment/view_shipments`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setdata(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => {
          setLoading(false);

        })
    }
    fetchData();
  }, [token, data]);

  const handleDelete = async (id) => {
    let delShipment = window.confirm("Do you want to delete");
    if (!delShipment) {
      return;
    }
    let res = await axios.delete(`${API}/api/shipment/delete_shipment/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (res) {
      window.location.reload();
    }
  };

  const handleSuspend = async (id, status) => {
    let sus = null;

    if (status === "active") {
      sus = window.confirm("Do you want to suspend the shipment?");

      if (!sus) {
        return;
      }

      await axios
        .get(`${API}/api/shipment/change_status/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          // window.location.reload()
        })
        .catch((error) => {
          console.log(error);
          // window.alert("Suspending of the current shipment failed");
        });
    } else {
      sus = window.confirm("Do you want to activate the shipment?");

      if (!sus) {
        return;
      }

      await axios
        .get(`${API}/api/shipment/change_status/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          // window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          window.alert("Activation of the current shipment failed");
        });
    }
  };
  //pagination
  useEffect(() => {
    const loadData = () => {
      const indexOfLastPost = currentPage * itemPerPage;
      const indexOfFirstPost = indexOfLastPost - itemPerPage;
      setShowData(data.slice(indexOfFirstPost, indexOfLastPost));
    };

    loadData();
  }, [data, currentPage, itemPerPage]);
  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          {/* <!-- start page title --> */}

          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Commerce - Shipping</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/dashboard'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>Commerce - Shipping</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- end page title --> */}

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row ml-0 mr-0  mb-10'>
                    <div className='col-sm-12 col-md-6'>&nbsp;</div>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dropdown d-block'>
                        <Link to='/shipping_add'>
                          <button
                            type='button'
                            className='btn btn-primary add-btn waves-effect waves-light float-right'>
                            <i className='fa fa-plus' aria-hidden='true'></i>{" "}
                            Add New Shipping Rate
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='table-responsive table-shoot'>
                    <table className='table table-centered table-nowrap mb-0'>
                      <thead className='thead-light'>
                        <tr>
                          <th>Name</th>
                          <th>Price</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#007bff" }}>
                                Loading...
                              </div>
                            </td>
                          </tr>
                        ) : showData?.length > 0 ?
                          (showData?.map((item) => (
                            <tr key={item._id}>
                              <td>{item.shipping_name}</td>
                              <td>
                                {getSymbolFromCurrency(currency)}{" "}
                                {item.shipping_rate}
                              </td>
                              <td>
                                {item.status === "active" ? (
                                  <span className='badge badge-pill badge-success font-size-12'>
                                    Live
                                  </span>
                                ) : (
                                  <span className='badge badge-pill badge-danger font-size-12'>
                                    Suspended
                                  </span>
                                )}
                              </td>
                              <td>
                                {item.status === "active" ? (
                                  <button
                                    type='button'
                                    className='btn btn-danger btn-sm  waves-effect waves-light btn-table'
                                    onClick={() =>
                                      handleSuspend(item._id, item.status)
                                    }>
                                    Suspend
                                  </button>
                                ) : (
                                  <button
                                    type='button'
                                    className='btn btn-success btn-sm  waves-effect waves-light btn-table'
                                    onClick={() =>
                                      handleSuspend(item._id, item.status)
                                    }>
                                    Make Live
                                  </button>
                                )}
                                {/* <button
                                    type="button"
                                    className="btn btn-success btn-sm  waves-effect waves-light btn-table"
                                    onClick={() =>
                                      handleSuspend(item._id, item.status)
                                    }
                                  >
                                    {item.status === "active"
                                      ? "Suspend"
                                      : "Make Live"}
                                  </button> */}
                                <Link to={`/shipping_edit/${item._id}`}>
                                  <button
                                    type='button'
                                    className='btn btn-primary btn-sm  waves-effect waves-light btn-table ml-2'>
                                    Edit
                                  </button>
                                </Link>

                                <button
                                  onClick={() => handleDelete(item._id)}
                                  type='button'
                                  className='btn btn-danger btn-sm  waves-effect waves-light btn-table ml-2'
                                  id='sa-params'>
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                          ) : (
                            <tr>
                              <td colSpan="10" align="center" style={{ padding: "20px" }}>
                                <div style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#ff0000" }}>
                                  No Shipping Address Found. Please add to display here.
                                </div>
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>

                  {/* <!-- end table-responsive --> */}
                  {/* Pagination */}
                  <div className='row mt-20'>
                    <div className='col-sm-12 col-md-6 mb-20'>
                      <div
                        className='dataTables_info'
                        id='datatable_info'
                        role='status'
                        aria-live='polite'>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, data?.length)} of{" "}
                        {data?.length} entries
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_paginate paging_simple_numbers float-right'>
                        <ul className='pagination'>
                          <li
                            className={
                              currentPage === 1
                                ? "paginate_button page-item previous disabled"
                                : "paginate_button page-item previous"
                            }>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='0'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev - 1)
                              }>
                              Previous
                            </a>
                          </li>

                          {!(currentPage - 1 < 1) && (
                            <li className='paginate_button page-item'>
                              <a
                                aria-controls='datatable'
                                data-dt-idx='1'
                                tabIndex='0'
                                className='page-link'
                                onClick={(e) =>
                                  setCurrentPage((prev) => prev - 1)
                                }>
                                {currentPage - 1}
                              </a>
                            </li>
                          )}

                          <li className='paginate_button page-item active'>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='2'
                              tabIndex='0'
                              className='page-link'>
                              {currentPage}
                            </a>
                          </li>

                          {!(
                            (currentPage + 1) * itemPerPage - itemPerPage >
                            data?.length
                          ) && (
                              <li className='paginate_button page-item '>
                                <a
                                  href='#'
                                  aria-controls='datatable'
                                  data-dt-idx='3'
                                  tabIndex='0'
                                  className='page-link'
                                  onClick={() => {
                                    setCurrentPage((prev) => prev + 1);
                                  }}>
                                  {currentPage + 1}
                                </a>
                              </li>
                            )}

                          <li
                            className={
                              !(
                                (currentPage + 1) * itemPerPage - itemPerPage >
                                data?.length
                              )
                                ? "paginate_button page-item next"
                                : "paginate_button page-item next disabled"
                            }>
                            <a
                              href='#'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev + 1)
                              }>
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- container-fluid --> */}
      </div>
      {/* <!-- End Page-content --> */}

      {/* <footer className="footer">
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<script>document.write(new Date().getFullYear())</script> © SoComOTT
						</div>

					</div>
				</div>
			</footer> */}
      <Footer />
    </div>
  );
}

export default AllShippings;
